import { NgModule } from "@angular/core";
import { CreateTagFunctionService } from "src/app/modules/bootstrap/pms-ui/functions/tag/create-tag/create-tag-function.service";

@NgModule({
  imports: [],
  providers: [CreateTagFunctionService]
})
export class CreateTagFunctionModule {}
